// extracted by mini-css-extract-plugin
module.exports = {"container":"upload_container__K6R1g","containerItem":"upload_containerItem__2S6bK","placeholder":"upload_placeholder__326tz"};